import React from "react";
import ReactModal from "react-modal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
ReactModal.setAppElement("#app");
const Modal = React.memo((props) => {
    const modalStyle = {
        overlay: {
            top: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            zIndex: 100,
        },
    };
    const iconStyle = { fontSize: 28 };
    const isOpen = props.open;
    const handleCloseModal = () => {
        props.closeModal();
    };
    return (React.createElement("div", { className: "App" },
        React.createElement(ReactModal, { style: modalStyle, isOpen: isOpen, onRequestClose: () => handleCloseModal(), className: props.overlayClass ? props.overlayClass : `sm:w-11/12 -sm:w-4/5 mx-auto p-4 mt-8 rounded-lg max-h-screen-9/10 overflow-y-scroll scroll_hidden bg-gray-50 relative`, shouldCloseOnOverlayClick: props.shouldCloseOnOverlayClick },
            (typeof (props.closebuttonUndisplay) === "undefined" || props.closebuttonUndisplay === false) &&
                React.createElement("div", { className: `${props.closeButtonResetClasses ? props.closeButtonResetClasses : "fixed sm:right-1/20 -sm:right-3/20"}` },
                    React.createElement("button", { onClick: () => handleCloseModal() },
                        React.createElement(FontAwesomeIcon, { icon: faTimes, style: iconStyle }))),
            props.leftHandler &&
                React.createElement("div", { className: "fixed top-1/2" },
                    React.createElement("button", { onClick: props.leftHandler ? props.leftHandler : () => { } },
                        React.createElement(FontAwesomeIcon, { icon: faArrowLeft, style: iconStyle }))),
            props.rightHandler &&
                React.createElement("div", { className: "fixed top-1/2 right-1/20" },
                    React.createElement("button", { onClick: props.rightHandler ? props.rightHandler : () => { } },
                        React.createElement(FontAwesomeIcon, { icon: faArrowRight, style: iconStyle }))),
            React.createElement("div", { className: "mt-2" }, props.children))));
});
export default Modal;
